import { FC } from 'react';
import { ManagedCommItem } from '../../../../../hooks/use-communications/types/managed-communication';
import { TemplateTransportType } from '../../../../../types/communication/transport-type';
import { EmailMangedCommCard } from './cards/email-card';
import { MailMangedCommCard } from './cards/mail-card';
import { PhoneMangedCommCard } from './cards/phone-card';
import { SmsManagedCommCard } from './cards/sms-card';

interface ManagedCommCardFactoryProps {
  communication: ManagedCommItem;
}

export const ManagedCommCardFactory: FC<ManagedCommCardFactoryProps> = (props) => {
  const { communication } = props;

  switch (communication.type) {
    case TemplateTransportType.Sms:
      return <SmsManagedCommCard communication={communication} />;
    case TemplateTransportType.Email:
      return <EmailMangedCommCard communication={communication} />;
    case TemplateTransportType.Voice:
      return <PhoneMangedCommCard communication={communication} />;
    case TemplateTransportType.Letter:
    case TemplateTransportType.Postcard:
      return <MailMangedCommCard communication={communication} />;
    default:
      return null;
  }
};
